import { EditForm } from 'ui/EditForm';
import { withAuth } from 'context/Auth';
import withContainer from 'components/Container/withContainer';
import FormField from 'ui/FormField/FormField';
import { CertificateDocModel, DocumentType } from 'api/api';
import {
    getCertificateInfo,
    useGenerateDocument
} from 'api/documents/documents';
import { useWithNumberId } from 'hooks/useId';
import { DOCUMENTS_PROPS, GenerateDocumentField } from '../constants';
import { DocumentObjectTitle } from '../Documents.styled';
import styled from 'styled-components';
import { getUserFullname } from 'utils/fullname';

const Field = FormField<CertificateDocModel>;

const StyledName = styled(DocumentObjectTitle)`
    font-weight: 500;
    text-align: center;
`;

const CertificateForm = () => {
    const getter = useWithNumberId(getCertificateInfo);
    const generate = useGenerateDocument(DocumentType.Certificate);
    return (
        <EditForm
            getter={getter} // Получаем данные организации
            saver={generate} // Сохраняем изменения
            successMessage="Свидетельство сформировано"
        >
            {({ values }) => (
                <>
                    <StyledName>{getUserFullname(values)}</StyledName>

                    <Field name="number" label="Номер документа" />

                    <Field
                        name="dateStart"
                        label="Дата начала прохождения курса"
                        type="date"
                    />
                    <Field
                        name="dateEnd"
                        label="Дата окончания прохождения курса"
                        type="date"
                    />

                    <Field name="hoursCount" label="Количество часов" />
                    <Field name="course" label="Квалификация" />

                    <GenerateDocumentField />
                </>
            )}
        </EditForm>
    );
};

export default withAuth(
    withContainer(CertificateForm, {
        heading: 'Свидетельство',
        ...DOCUMENTS_PROPS
    })
);
